import { useEffect, useState } from "react";
import type { MutableRefObject } from "react";

/**
 * Специфичный хук для определения того, что родительский элемент
 * Имеет ширину дочерних элементов, которая превышает ширину самого родительского элемента
 * @param ref Родительский элемент, в котором находится элемент, который должен быть затроеточен,
 * когда он не помещается полностью при переносе на вторую строку
 */
export const useTruncateTag = (
  ref: MutableRefObject<HTMLElement | null>
): boolean => {
  const [shouldBeTruncated, setShouldBeTruncated] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const parent = ref.current;

    const updateTruncationState = () => {
      const parentWidth = parent.offsetWidth;
      let totalChildWidth = 0;

      parent.childNodes.forEach(child => {
        if (child instanceof HTMLElement) {
          totalChildWidth += child.offsetWidth;
        }
      });

      setShouldBeTruncated(totalChildWidth >= parentWidth);
    };

    updateTruncationState();

    const resizeObserver = new ResizeObserver(updateTruncationState);
    resizeObserver.observe(parent);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref]);

  return shouldBeTruncated;
};
